import throttle from 'lodash/throttle';

export default function () {
  const bodyEl = document.querySelector('.body');
  const fullWidthSections = document.querySelectorAll('.menu:not(:first-child), .full-width-image-and-text:not(:first-child), .carousel:not(:first-child)');

  function checkBackgroundPosition() {
    let backgroundImageBottom = false;

    fullWidthSections.forEach((fullWidthSection) => {
      const centerSection = fullWidthSection.offsetTop + (fullWidthSection.offsetHeight / 2);
      const centerWindow = window.scrollY + (window.innerHeight / 2);

      if (centerSection < centerWindow) {
        backgroundImageBottom = !backgroundImageBottom;
      }
    });

    if (backgroundImageBottom) {
      bodyEl.classList.add('body--bg-image-bottom');
    } else {
      bodyEl.classList.remove('body--bg-image-bottom');
    }
  }

  if (fullWidthSections && bodyEl && bodyEl.getAttribute('class').includes('body--bg-image-')) {
    window.addEventListener('scroll', throttle(checkBackgroundPosition, 300));
  }
}
